import React from 'react'
import AccountLayout from '../../components/account/layout'
import UniversalSwitchLayout from '../../components/account/universalPageSwitchLayout'
import { useLocation } from "react-router-dom";

function Carddetails() {
    const { pathname } = useLocation();
    
    React.useEffect(() => {
        window.scrollTo(0, 0);
      }, [pathname]);

    return (
        <div>
            <AccountLayout>
                <UniversalSwitchLayout page="carddetails" />
            </AccountLayout>
        </div>
    )
}

export default Carddetails